/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCollapseCHClosedIcon20Regular = forwardRef('ArrowCollapseCHClosedIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M11.742 8.197a2.55 2.55 0 0 0 0 3.606l3.978 3.977a.75.75 0 1 0 1.06-1.06l-3.977-3.978a1.05 1.05 0 0 1 0-1.484L16.78 5.28a.75.75 0 0 0-1.06-1.06l-3.978 3.977Z" }),
        React.createElement("path", { d: "M8.258 8.197a2.55 2.55 0 0 1 0 3.606L4.28 15.78a.75.75 0 0 1-1.06-1.06l3.977-3.978a1.05 1.05 0 0 0 0-1.484L3.22 5.28a.75.75 0 0 1 1.06-1.06l3.978 3.977Z" })));
});
